/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Proxy_Progress_LabelInputs */



/**
* | output |
* | --- |
* | "Proxy import progress" |
*
* @param {Iconik_Proxy_Progress_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_proxy_progress_label = /** @type {((inputs?: Iconik_Proxy_Progress_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Proxy_Progress_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de l'import du proxy")
	if (locale === "de") return /** @type {LocalizedString} */ ("Proxy-Importfortschritt")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzamento dell'importazione del proxy")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход импорта прокси")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de la importación de proxy")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("代理导入进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プロキシインポートの進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रॉक्सी आयात प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso da importação de proxy")
	return /** @type {LocalizedString} */ ("Proxy import progress")
});